var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('div',{staticClass:"columns columns--cards",style:({
      'background-color': _vm.useBackgroundColor,
      'padding-top': _vm.paddingTop + 'px',
      'padding-bottom': _vm.paddingBottom + 'px'
    })},[_c('div',{staticClass:"columns columns--cards"},_vm._l((_vm.blocks),function(block,idx){return _c('info-tooltip',{key:idx,staticClass:"column col-6 sm-col-12",attrs:{"fields":_vm.convertBlockFields(block)}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }